import React from 'react';

import './styles.scss';

export interface SwitcherProps {
  isEnabled: boolean;
  onToggle: () => void;
  label?: React.ReactNode;
}

export function Switcher({ isEnabled, onToggle, label }: SwitcherProps) {
  return (
    <div className="Switcher-container">
      {label && <span className="Switcher-label">{label}</span>}
      <button
        onClick={onToggle}
        className={`Switcher-button ${isEnabled ? 'enabled' : ''}`}
        aria-pressed={isEnabled}
        aria-label={`${label} toggle`}
      >
        <span className="Switcher-slider" />
      </button>
    </div>
  );
}
